import React, { Component } from "react";
import HomologarTitularMayorComponent from "../../../components/personaReferencia/homologarTitularMayor/HomologarTitularMayorComponent";
import { homologarTitularMayorStore } from "./HomologarTitularMayor.store";
import { homologarTitularMayorDispatcher } from "./HomologarTitularMayor.dispatcher";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import ModalFrame from "../../../../toolkit/modalFrame";

interface Props {
  idMembresiaSocio: number;
  idTitular: number;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

interface State {}

@ReduxConnect(homologarTitularMayorStore, homologarTitularMayorDispatcher)
export default class HomologarTitularMayorModal extends Component<
  Props,
  State
> {
  state = {};

  render() {
    return (
      <ModalFrame
        title="Homologar Titular Mayor de Edad"
        isOpen={this.props.isOpen}
        toggle={this.props.onClose}
        size="md"
      >
        <HomologarTitularMayorComponent {...(this.props as any)} />
      </ModalFrame>
    );
  }
}
